const sortDropdown = document.querySelectorAll('.sort-dropdown');

if (sortDropdown.length > 0) {
  const hideSortDropdown = () => {
    sortDropdown.forEach((item) => {
      item.classList.remove('is-open');
    });
  };

  // Open sort dropdown
  attachEvent('.sort-dropdown__placeholder', 'click', (ev) => {
    const parentElem = ev.target.closest('.sort-dropdown');
    parentElem.classList.toggle('is-open');
  });

  // Close sort dropdown When Escape Key Press
  onKeydown('escape', () => {
    hideSortDropdown();
  });

  // Close sort dropdown Click Out
  document.addEventListener('click', (evt) => {
    sortDropdown.forEach((item) => {
      if (!item.contains(evt.target)) {
        item.classList.remove('is-open');
      }
    });
  });

  // Close Sort Dropdown
  document.addEventListener('change', (event) => {
    const input = event.target.closest('.sort-dropdown input');
    if (!input) return;
    hideSortDropdown();
  });

  attachEvent('[data-close-sort]', 'click', () => {
    hideSortDropdown();
  });
}
